import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, tap } from "rxjs";
import { AuditTrailServiceService } from
  "src/app/core-module/grn/del-po/audit-trail/audit-trail-service.service";

@Injectable()
export class AuditInterceptor implements HttpInterceptor {

  constructor(
    private auditService: AuditTrailServiceService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const isAuditRequest = req.headers.has('X-Audit');
    const isExcluded = this.shouldExclude(req.url);

    // ✅ Only CREATE / UPDATE / DELETE
    const isDataChangingMethod = ['POST', 'PUT', 'PATCH', 'DELETE']
      .includes(req.method);

    const shouldAudit = isDataChangingMethod && !isAuditRequest && !isExcluded;

    return next.handle(req).pipe(
      tap((event) => {

        if (!(event instanceof HttpResponse) || !shouldAudit) return;

        // 🔹 Employee ID
        let employeeId = 0;
        const userDetails = localStorage.getItem('user_details');

        if (userDetails) {
          try {
            const parsed = JSON.parse(userDetails);
            employeeId = parsed.employeeId || parsed.empId || 0;
          } catch {
            employeeId = 0;
          }
        }

        // 🔹 Data (sirf request body)
        let newData: any = {};

        if (req.body && typeof req.body === 'object') {
          newData = { ...req.body };
        }

        // 🔹 Route info
        const currentUrl =
          this.router.url && this.router.url !== '/'
            ? this.router.url
            : window.location.pathname;

        const routeInfo = this.extractRouteDetails(currentUrl);

        const payload = {
          user_id: employeeId,
          role: routeInfo.role,
          module_name: routeInfo.module,
          page_name: routeInfo.page,
          full_route: routeInfo.fullRoute,
          action_type: this.getActionType(req.method),
          previous_data: null,
          new_data: newData
        };

        this.auditService.logAuditTrail(payload).subscribe({
          error: (err) => console.error('Audit Error:', err)
        });

      })
    );
  }

  private extractRouteDetails(url: string) {

    const segments = url.split('/').filter(Boolean);

    let role = 'GENERAL';
    let module = 'UNKNOWN';
    let page = 'UNKNOWN';

    if (segments.length >= 2) {

      if (segments[0].toLowerCase() === 'admin' ||
          segments[0].toLowerCase() === 'vendor') {

        role = segments[0].toUpperCase();
        module = segments[1].toUpperCase();
        page = segments[2]?.toUpperCase() || 'LIST';
      } 
      else {
        module = segments[0].toUpperCase();
        page = segments[1]?.toUpperCase() || 'LIST';
      }
    }

    return {
      role,
      module,
      page,
      fullRoute: url
    };
  }

  private getActionType(method: string): 'CREATE' | 'UPDATE' | 'DELETE' {
    switch (method) {
      case 'POST': return 'CREATE';
      case 'PUT':
      case 'PATCH': return 'UPDATE';
      case 'DELETE': return 'DELETE';
      default: return 'UPDATE';
    }
  }

  private shouldExclude(url: string): boolean {
    const excludedEndpoints = [
      '/dropdown',
      '/search',
      '/filter',
      '/lookup',
      '/autocomplete'
    ];

    return excludedEndpoints.some(pattern =>
      url.toLowerCase().includes(pattern)
    );
  }
}